import React, { createContext, useContext, useMemo } from "react";
import { useStaticQuery, graphql } from "gatsby";

const SiteSettingsContext = createContext(null);

const SiteSettingsProvider = ({ children }) => {
    const data = useStaticQuery(graphql`
        query SiteSettingsQuery {
            siteSettings {
                settingsJson
                snippetsJson
            }
        }
    `);

    const value = useMemo(() => ({
        settings: JSON.parse(data.siteSettings.settingsJson),
        snippets: JSON.parse(data.siteSettings.snippetsJson),
    }), [data.siteSettings.settingsJson, data.siteSettings.snippetsJson]);

    return (
        <SiteSettingsContext.Provider value={value}>
            {children}
        </SiteSettingsContext.Provider>
    );
};

export const useSiteSettings = () => {
    const context = useContext(SiteSettingsContext);
    if (context === null) {
        throw new Error("useSiteSettings must be used within a SiteSettingsProvider");
    }
    return context.settings;
};

export const useSiteSnippets = () => {
    const context = useContext(SiteSettingsContext);
    if (context === null) {
        throw new Error("useSiteSnippets must be used within a SiteSettingsProvider");
    }
    return context.snippets;
};

export default SiteSettingsProvider;
